export default "__VITE_ASSET__C1XyW3Xs__"